module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column h-100 position-relative"
  }, [_c('div', {
    staticClass: "flexGrow1 overflow-auto"
  }, [(_vm.getIsLoadingSupplierIntegrations) ? _c('div', {
    staticClass: "d-flex flex-column justify-content-center align-items-center",
    staticStyle: {
      "height": "90vmin"
    }
  }, [_c('label', {
    staticClass: "fs-larger darker"
  }, [_vm._v("Loading")]), _vm._v(" "), _c('loader')], 1) : _vm._e(), _vm._v(" "), (!_vm.getIsLoadingSupplierIntegrations) ? _c('div', {
    staticClass: "bg-lightest col-sm-12 d-flex flex-column"
  }, _vm._l((_vm.getAllIntegrationsGroupedes), function(integrationGroup) {
    return _c('div', {
      key: integrationGroup.id,
      staticClass: "mb-3"
    }, [(integrationGroup.integrations.length > 0) ? _c('div', [_c('h3', [_vm._v(_vm._s(integrationGroup.label))]), _vm._v(" "), _c('div', {
      staticClass: "dark"
    }, [_vm._v(_vm._s(integrationGroup.description))]), _vm._v(" "), (integrationGroup.integrations.length < 1) ? _c('div', [_c('div', {
      staticClass: "dark p-4"
    }, [_vm._v("No integrations available")])]) : _c('div', {
      staticClass: "d-flex flex-row flex-wrap"
    }, _vm._l((_vm.getIntegrationsWithoutOCTO(integrationGroup.integrations)), function(integration) {
      return _c('integration-card', {
        key: integration.id,
        staticClass: "m-3",
        attrs: {
          "integration": integration
        }
      })
    }), 1)]) : _vm._e()])
  }), 0) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-43c11489", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c11489"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/Integrations.vue
// module id = 2539
// module chunks = 0